export default "__VITE_ASSET__C9ET$mee__"